import * as React from 'react'
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';

type Props = {
  className?: string,
  label: string,
  value: any,
  isMatched: boolean,
  size?: 'small' | "big"
}



const TerminalStat: React.FC<Props> = ({ label, value, isMatched, size="big", className = '' }) => {
  const sizeClass = size === 'big'? 'text-4xl': 'text-2xl';
  return (
    <div className={'px-6 py-4 ' + className}>
      <div className="flex justify-evenly items-center">
        <div className={"text-center " + sizeClass}>{value}</div>
        <div className="pl-1">
          {isMatched === true &&
            <CheckIcon className="text-green-700" />
          }
          {isMatched === false &&
            <ClearIcon className="text-red-700" />
          }
        </div>
      </div>
      <h3 className="fond-bold text-sm pt-1 text-gray-700 text-center">{label}</h3>
    </div>
  );
}

export default TerminalStat;

